import { Observable } from 'rxjs';
import { StatusPreautorisation } from '../shared/modeles/variables';

export abstract class ToolPreautorisationService {
  abstract version: string;

  /* Automatique */
  abstract isPreautFormInProgress$: Observable<boolean>;

  abstract isPreautResetWithoutWarning$: Observable<boolean>;

  abstract isCoemprunteur$: Observable<boolean>;

  abstract isSecondCoemprunteur$: Observable<boolean>;

  abstract getStatusPreautorisation$: Observable<StatusPreautorisation>;

  abstract getStatusAndIsLoadedPreautorisation$: Observable<{
    isPreautLoaded: boolean;
    status: StatusPreautorisation;
    currentStep: string;
    isSecondCoemprunteur: boolean;
    isCoemprunteur: boolean;
  }>;

  abstract preautAmount$: Observable<number>;

  abstract isPreautExpiringSoon$: Observable<boolean>;

  abstract lastDayBeforeExpirationPreautEnLigne$: Observable<Date>;

  abstract isRateExpiringSoon$: Observable<boolean>;

  abstract dateExpirationTaux$: Observable<Date>;

  abstract getPreautorisation$: Observable<any>;

  abstract dashboardComponent: unknown;

  abstract debugComponent: unknown;

  abstract initialize(): Promise<void>;

  abstract patchDebugOnly(data?: Partial<any>);

  abstract debugGoToStep(step: string);

  abstract debugSetStatus(status: string);

  abstract initPreautorisationEnLigne();

  abstract setPreautorisation(preautorisation);

  abstract resetPreautorisation();

  abstract annulerPreautorisation(): Promise<void>;

  abstract annulerPreautorisationAvecConfirmation(returnUrl: string): Promise<void>;
}
